module.exports = __webpack_public_path__ + "img/bagging_woodpacking.a461a246.svg";